<script>

    import View from '../$layouts/view.layout.svelte'

    import ModalContainer from '../$components/modal.container.svelte'

    import CreditsComponent from './component.credits.svelte'
    import CreditComponent from './component.credit.svelte'
    import CreditUpdateComponent from './component.update.svelte'

    import TitleHero from '../$components/title.hero.svelte'

    export let all = true

</script>

<View>
    <div>
        <TitleHero title="Créditos" subtitle="Consulta y gestión de créditos" />
        <CreditsComponent {all} />
    </div>
</View>

<ModalContainer id="credit_modal" title="Detalle del crédito">
    <CreditComponent />
</ModalContainer>

<ModalContainer id="credit_update_modal" title="Actualizar crédito">
    <CreditUpdateComponent />
</ModalContainer>
